/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AiToAiTestResponse } from '../models/AiToAiTestResponse';

import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';

export class AiToAiTestService {

  constructor(public readonly httpRequest: BaseHttpRequest) {}

  /**
   * Löst einen Test Call aus
   * Wir wollen zyklisch diesen Endpunkt aufrufen, um einen Test Call zu lösen, um bspw. Auswertungen und Anrufsqualität zu prüfen.
   * @returns AiToAiTestResponse AI zu AI Call erfolgreich erstellt
   * @throws ApiError
   */
  public aiToAiTestCall(): CancelablePromise<AiToAiTestResponse> {
    return this.httpRequest.request({
      method: 'POST',
      url: '/api/intern/ai-to-ai-test-call',
      errors: {
        401: `Unauthorized for this request (aiToAiCall)`,
        403: `Forbidden for this request (aiToAiCall)`,
        404: `Something is Not Found`,
      },
    });
  }

}
